import LinearGradient from "./LinearGradient.js";
/**
 * All props pass through to `<LinearGradient {...props} />`
 */
import { jsx as _jsx } from "react/jsx-runtime";
export default function GradientLightgreenGreen(_ref) {
  let {
    from = '#42E695',
    to = '#3BB2B8',
    ...restProps
  } = _ref;
  return /*#__PURE__*/_jsx(LinearGradient, {
    from: from,
    to: to,
    ...restProps
  });
}